export class CustomerAddress {
	id?: string;
	description?: string;
	address?: string;
	city?: string;
	country?: string;
	zipCode?: string;
	province?: string;
}
